var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
    }
    LocalStorage.prototype.isEnabled = function () {
        /* istanbul ignore if */
        if (typeof window === 'undefined') {
            return false;
        }
        var random = String(Date.now());
        var testStrorage = new LocalStorage();
        var testKey = 'AMP_TEST';
        try {
            testStrorage.set(testKey, random);
            var value = testStrorage.get(testKey);
            return value === random;
        }
        catch (_a) {
            /* istanbul ignore next */
            return false;
        }
        finally {
            testStrorage.remove(testKey);
        }
    };
    LocalStorage.prototype.get = function (key) {
        try {
            var value = this.getRaw(key);
            if (!value) {
                return undefined;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return JSON.parse(value);
        }
        catch (_a) {
            /* istanbul ignore next */
            return undefined;
        }
    };
    LocalStorage.prototype.getRaw = function (key) {
        return window.localStorage.getItem(key) || undefined;
    };
    LocalStorage.prototype.set = function (key, value) {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        }
        catch (_a) {
            //
        }
    };
    LocalStorage.prototype.remove = function (key) {
        try {
            window.localStorage.removeItem(key);
        }
        catch (_a) {
            //
        }
    };
    LocalStorage.prototype.reset = function () {
        try {
            window.localStorage.clear();
        }
        catch (_a) {
            //
        }
    };
    return LocalStorage;
}());
export { LocalStorage };
//# sourceMappingURL=local-storage.js.map